import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
import { Check, X, ChevronDown } from 'lucide-react';
export const Offer = () => {
  const {
    setCurrentPage,
    timeLeft
  } = useAppContext();
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  return <div className="min-h-screen bg-bg pb-24" data-id="element-168">
      <div className="max-w-[720px] mx-auto px-5 pt-6" data-id="element-169">
        {/* Hero */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-dark text-white py-9 px-6 text-center rounded-2xl mb-5" data-id="element-170">
          <span className="inline-block py-1 px-3.5 rounded-full text-[13px] font-semibold bg-[#FFF8E1] text-[#F59E0B]" data-id="element-171">
            🎓 CERTIFICADO EUROPEO OFICIAL INCLUIDO
          </span>
          <h1 className="text-[23px] sm:text-[30px] font-extrabold leading-[1.3] my-3" data-id="element-172">
            El sistema completo para dominar la IA en Gestión de Proyectos — y
            certificarte con reconocimiento europeo oficial
          </h1>
          <p className="text-[16px] opacity-85 leading-[1.6]" data-id="element-173">
            30 horas prácticas · 100% online · A tu ritmo · Desde cualquier
            lugar de LATAM
          </p>
        </motion.div>

        {/* Problem Section */}
        <div className="bg-[#FFF8F0] rounded-2xl p-6 border-l-4 border-primary mb-5" data-id="element-174">
          <h3 className="text-[20px] font-bold mb-3.5 text-dark" data-id="element-175">
            😤 ¿Te suena familiar?
          </h3>
          <ul className="space-y-2 mb-4" data-id="element-176">
            {['Pierdes horas cada semana en reportes y documentación repetitiva', 'Usas ChatGPT pero los resultados son genéricos e inútiles para proyectos', 'Ves cómo la IA transforma tu sector pero no sabes por dónde empezar', 'Tu CV es igual al de miles de Project Managers — sin diferenciación', 'Sientes que tu perfil podría quedar obsoleto en los próximos 2-3 años'].map((item, i) => <li key={i} className="flex gap-2 text-[15px] leading-[1.5]" data-id="element-177">
                <span className="shrink-0" data-id="element-178">❌</span>
                <span data-id="element-179">{item}</span>
              </li>)}
          </ul>
          <p className="text-[15px] font-semibold text-dark mt-3.5" data-id="element-180">
            El problema no es ChatGPT. El problema es que nadie te ha enseñado
            el sistema correcto para aplicar la IA específicamente a la gestión
            de proyectos.
          </p>
        </div>

        {/* Mechanism */}
        <div className="bg-dark text-white rounded-2xl p-7 mb-5" data-id="element-181">
          <h3 className="text-[22px] font-extrabold text-center mb-5 text-gold" data-id="element-182">
            ⚙️ PRESENTANDO EL MÉTODO CERTO
          </h3>
          <p className="text-center opacity-80 mb-5 text-[14px]" data-id="element-183">
            El único sistema de Prompt Engineering diseñado específicamente para
            las 5 fases del ciclo de vida de un proyecto
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-184">
            {[{
            l: 'C',
            t: 'Contexto Preciso',
            d: 'Para cada fase del proyecto'
          }, {
            l: 'E',
            t: 'Estructura',
            d: 'Prompts por herramienta'
          }, {
            l: 'R',
            t: 'Rol de IA',
            d: 'Específico en tu equipo'
          }, {
            l: 'T',
            t: 'Técnica',
            d: 'Adaptada a tu proyecto'
          }].map((item, i) => <div key={i} className="bg-white/5 rounded-xl p-3.5" data-id="element-185">
                <div className="text-[28px] font-black text-primary leading-none mb-1" data-id="element-186">
                  {item.l}
                </div>
                <div className="text-[13px] font-bold mb-1" data-id="element-187">{item.t}</div>
                <div className="text-[12px] opacity-70 leading-[1.4]" data-id="element-188">
                  {item.d}
                </div>
              </div>)}
          </div>
          <div className="bg-white/5 rounded-xl p-3.5 mt-3 text-center" data-id="element-189">
            <div className="text-[28px] font-black text-primary leading-none mb-1" data-id="element-190">
              O
            </div>
            <div className="text-[13px] font-bold mb-1" data-id="element-191">
              Optimización Continua
            </div>
            <div className="text-[12px] opacity-70 leading-[1.4]" data-id="element-192">
              Mejora constante de resultados
            </div>
          </div>
        </div>

        {/* Modules */}
        <div className="mb-5" data-id="element-193">
          <h3 className="text-[22px] font-extrabold text-center text-dark mb-4" data-id="element-194">
            📚 LOS 8 MÓDULOS DEL PROGRAMA
          </h3>

          {[{
          n: 1,
          t: 'Fundamentos y Herramientas de IA para Gestión de Proyectos',
          d: 'El Método CERTO explicado desde cero. Tu primera automatización funcionando antes de terminar el módulo.',
          v: '$97'
        }, {
          n: 2,
          t: 'Planificación y Documentación con IA y Notion AI',
          d: 'Actas de constitución completas en 5 minutos. Espacios de trabajo inteligentes. Bases de conocimiento automáticas.',
          v: '$97'
        }, {
          n: 3,
          t: 'Documentación Avanzada con NotebookLM + Miro AI',
          d: 'NotebookLM como asistente de tus propios archivos. Mapas mentales y diagramas automáticos con Miro AI.',
          v: '$97'
        }, {
          n: 4,
          t: 'Automatización de Tareas con JIRA + Zapier + ChatGPT',
          d: 'Automatiza tickets y tareas en JIRA. Conecta todas tus herramientas con Zapier sin código.',
          v: '$97'
        }, {
          n: 5,
          t: 'Control y Seguimiento con ChatGPT + Power BI',
          d: 'Dashboards de KPIs con IA. Key Influencers y Árbol de Descomposición. Reportes automáticos.',
          v: '$97'
        }, {
          n: 6,
          t: 'Funcionalidades Avanzadas de IA en Power BI',
          d: 'Análisis predictivo. Detección automática de riesgos. Dashboards ejecutivos en tiempo real.',
          v: '$97'
        }, {
          n: 7,
          t: 'Planificación y Control con GPTs Personalizados',
          d: 'Crea tu propio GPT para cada fase del proyecto. Tu asistente de IA con TU metodología.',
          v: '$197'
        }, {
          n: 8,
          t: 'Cierre Inteligente y Gestión del Conocimiento',
          d: 'Lecciones aprendidas con IA. Informes de cierre automáticos. Biblioteca de conocimiento organizacional.',
          v: '$97'
        }].map((mod, i) => <div key={i} className="bg-white border border-border rounded-xl p-4 mb-2.5 flex gap-3.5 items-start" data-id="element-195">
              <div className="bg-primary text-white w-9 h-9 rounded-lg flex items-center justify-center font-extrabold text-[16px] shrink-0" data-id="element-196">
                {mod.n}
              </div>
              <div data-id="element-197">
                <h4 className="text-[15px] font-bold text-dark mb-1" data-id="element-198">
                  {mod.t}
                </h4>
                <p className="text-[13px] text-textlight leading-[1.5]" data-id="element-199">
                  {mod.d}
                </p>
                <span className="text-[11px] bg-surface text-textlight py-0.5 px-2 rounded-full inline-block mt-1" data-id="element-200">
                  Valor: {mod.v} USD
                </span>
              </div>
            </div>)}
        </div>

        {/* Bonuses */}
        <div className="bg-gradient-to-br from-[#FFF8E1] to-[#FFF3E0] rounded-2xl p-6 mb-5 border-2 border-dashed border-gold" data-id="element-201">
          <h3 className="text-[20px] font-extrabold text-center mb-4 text-dark" data-id="element-202">
            🎁 BONUSES EXCLUSIVOS INCLUIDOS HOY
          </h3>

          {[{
          i: '📋',
          t: 'Pack de Plantillas IA Avanzadas para Gestión de Proyectos',
          d: '20+ plantillas listas: actas, reportes, retrospectivas, dashboards, cierre. Ahorra 3-4 horas desde el primer proyecto.',
          v: '$197'
        }, {
          i: '🔑',
          t: 'Guía de Prompt Engineering CERTO para Project Managers',
          d: '50+ prompts especializados para cada fase del proyecto. El cheat sheet que todo PM con IA necesita.',
          v: '$97'
        }, {
          i: '👥',
          t: 'Comunidad Privada: "Project Managers con IA — LATAM"',
          d: 'Red de profesionales usando IA en proyectos reales. Casos de uso, actualizaciones y networking.',
          v: '$97'
        }].map((bonus, i) => <div key={i} className={`flex gap-3 py-3 items-start ${i !== 2 ? 'border-b border-black/5' : ''}`} data-id="element-203">
              <div className="text-[24px] shrink-0" data-id="element-204">{bonus.i}</div>
              <div data-id="element-205">
                <h4 className="text-[14px] font-bold mb-1" data-id="element-206">{bonus.t}</h4>
                <p className="text-[13px] text-textlight" data-id="element-207">{bonus.d}</p>
                <div className="text-[12px] mt-1" data-id="element-208">
                  <s className="text-textlight" data-id="element-209">{bonus.v} USD</s> →{' '}
                  <span className="text-success font-bold" data-id="element-210">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Before / After */}
        <div className="bg-surface rounded-2xl p-5 mb-5" data-id="element-211">
          <h3 className="text-center text-[20px] font-extrabold mb-4 text-dark" data-id="element-212">
            🔄 TU TRANSFORMACIÓN REAL
          </h3>
          <div className="grid grid-cols-2 gap-3" data-id="element-213">
            <div data-id="element-214">
              <h4 className="text-center text-[14px] font-bold p-2 rounded-lg mb-2.5 bg-[#FFEBEE] text-[#C62828]" data-id="element-215">
                ANTES ❌
              </h4>
              <ul className="space-y-1.5" data-id="element-216">
                {['8h+ en reportes manuales', 'Documentación caótica', 'CV igual al de todos', 'Miedo a quedarte obsoleto', 'Proyectos que se retrasan', 'Trabajo hasta tarde'].map((item, i) => <li key={i} className="text-[13px] leading-[1.4] flex gap-1.5" data-id="element-217">
                    <span className="shrink-0" data-id="element-218">❌</span>
                    <span data-id="element-219">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-220">
              <h4 className="text-center text-[14px] font-bold p-2 rounded-lg mb-2.5 bg-[#E8F5E9] text-[#00C853]" data-id="element-221">
                DESPUÉS ✅
              </h4>
              <ul className="space-y-1.5" data-id="element-222">
                {['45 min con IA automatizada', 'Base de conocimiento inteligente', 'Certificado Europeo en LinkedIn', 'Líder de la transformación IA', 'Proyectos bajo control total', 'Tiempo para lo que importa'].map((item, i) => <li key={i} className="text-[13px] leading-[1.4] flex gap-1.5" data-id="element-223">
                    <span className="shrink-0" data-id="element-224">✅</span>
                    <span data-id="element-225">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        {/* Certificate */}
        <div className="bg-gradient-to-br from-[#0A0E27] to-[#1a2744] text-white rounded-2xl p-7 mb-5 text-center" data-id="element-226">
          <div className="text-[48px] mb-3" data-id="element-227">🏅</div>
          <h3 className="text-[22px] font-extrabold text-gold mb-1.5" data-id="element-228">
            CERTIFICADO EUROPEO OFICIAL INCLUIDO
          </h3>
          <p className="text-[15px] opacity-85 mb-4" data-id="element-229">
            Al completar el programa recibes tu Certificado Homologado Europeo
            en Gestión Avanzada de Proyectos con IA — avalado por AIN (España)
          </p>
          <div className="flex justify-center gap-3 flex-wrap mb-4" data-id="element-230">
            <div className="bg-white/10 rounded-lg py-2 px-4 text-[13px]" data-id="element-231">
              🌍 Válido en 40+ países
            </div>
            <div className="bg-white/10 rounded-lg py-2 px-4 text-[13px]" data-id="element-232">
              ✅ Verificable online
            </div>
            <div className="bg-white/10 rounded-lg py-2 px-4 text-[13px]" data-id="element-233">
              💼 Para tu LinkedIn
            </div>
            <div className="bg-white/10 rounded-lg py-2 px-4 text-[13px]" data-id="element-234">
              🏆 Reconocido oficialmente
            </div>
          </div>
          <p className="text-[13px] opacity-70" data-id="element-235">
            Un certificado europeo equivalente cuesta entre $500-$2,000 USD en
            instituciones europeas. Tú lo obtienes incluido.
          </p>
        </div>

        {/* Testimonials */}
        <div className="mb-5" data-id="element-236">
          <h3 className="text-[20px] font-extrabold text-center text-dark mb-4" data-id="element-237">
            ⭐ LO QUE DICEN NUESTROS ESTUDIANTES
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-238">
            {[{
            t: '"Pasé de 6 horas a 35 minutos en mi reporte semanal. El módulo de Power BI + IA solo ya valió todo el programa."',
            a: 'Carlos M., PM Senior · México'
          }, {
            t: '"Añadí el certificado a LinkedIn y en 3 semanas recibí 2 ofertas de trabajo remoto de empresas españolas."',
            a: 'Valentina R., Consultora · Colombia'
          }, {
            t: '"El Método CERTO me demostró que cualquier PM puede implementar IA sin saber programar. Transformó mi forma de trabajar."',
            a: 'Diego F., Director de Proyectos · Chile'
          }, {
            t: '"Ahora manejo el doble de proyectos con la mitad del esfuerzo gracias a JIRA + Zapier + ChatGPT."',
            a: 'Andrea P., Emprendedora · Perú'
          }].map((testi, i) => <div key={i} className="bg-white rounded-xl p-4 shadow-[0_2px_12px_rgba(0,0,0,0.06)] border-l-[3px] border-primary" data-id="element-239">
                <div className="text-gold text-[13px] mb-1.5" data-id="element-240">⭐⭐⭐⭐⭐</div>
                <div className="text-[13px] italic text-text leading-[1.5] mb-2" data-id="element-241">
                  {testi.t}
                </div>
                <div className="text-[12px] text-textlight font-semibold" data-id="element-242">
                  — {testi.a}
                </div>
              </div>)}
          </div>
        </div>

        {/* Pricing */}
        <div className="bg-surface rounded-2xl p-7 text-center mb-5" data-id="element-243">
          <h3 className="text-[22px] font-extrabold text-dark mb-5" data-id="element-244">
            💰 TU INVERSIÓN HOY
          </h3>
          <div className="bg-white rounded-2xl p-7 shadow-[0_8px_40px_rgba(0,0,0,0.12)] max-w-[420px] mx-auto border-[3px] border-primary" data-id="element-245">
            <div className="text-[16px] text-textlight line-through" data-id="element-246">
              Valor real: $1,267 USD · Precio normal: $497 USD
            </div>
            <div className="text-[54px] font-black text-primary leading-none my-1" data-id="element-247">
              $297
            </div>
            <div className="text-[14px] text-textlight mb-4" data-id="element-248">
              USD · Pago único · Acceso de por vida
            </div>
            <div className="bg-[#E8F5E9] text-success rounded-lg py-2 px-4 text-[14px] font-bold mb-4 inline-block" data-id="element-249">
              🎉 Ahorras $970 USD — 77% de descuento
            </div>
            <ul className="text-left space-y-3 mb-5" data-id="element-250">
              {[{
              i: '✅',
              t: '8 Módulos Prácticos Completos'
            }, {
              i: '🏅',
              t: 'Certificado Europeo Oficial'
            }, {
              i: '📋',
              t: 'Pack Plantillas IA Avanzadas ($197)'
            }, {
              i: '🔑',
              t: 'Guía Prompts CERTO ($97)'
            }, {
              i: '👥',
              t: 'Comunidad Privada LATAM ($97)'
            }, {
              i: '♾️',
              t: 'Acceso de por vida'
            }, {
              i: '🛡️',
              t: 'Garantía 15 días sin preguntas'
            }].map((item, i) => <li key={i} className="flex gap-2 text-[14px] border-b border-border pb-2 last:border-0 last:pb-0" data-id="element-251">
                  <span className="shrink-0" data-id="element-252">{item.i}</span>
                  <span data-id="element-253">{item.t}</span>
                </li>)}
            </ul>
            <button onClick={() => setCurrentPage('checkout')} className="bg-primary hover:bg-primary-hover text-white border-none rounded-xl py-4 px-8 text-[17px] font-bold cursor-pointer w-full block transition-all duration-200 shadow-primary hover:-translate-y-0.5" data-id="element-254">
              👉 QUIERO MI CERTIFICACIÓN AHORA →
            </button>
            <p className="text-[12px] text-textlight text-center mt-2.5" data-id="element-255">
              O 3 pagos de $109 USD · 💳 Visa · Mastercard · PayPal · Mercado
              Pago
            </p>
          </div>
        </div>

        {/* Guarantee */}
        <div className="bg-[#E8F5E9] rounded-2xl p-6 text-center mb-5 border-2 border-success" data-id="element-256">
          <div className="text-[48px]" data-id="element-257">🛡️</div>
          <h3 className="text-[20px] font-extrabold text-[#1B5E20] my-2" data-id="element-258">
            GARANTÍA TOTAL DE 15 DÍAS
          </h3>
          <p className="text-[14px] text-[#2E7D32] leading-[1.6]" data-id="element-259">
            Si por cualquier motivo no estás satisfecho/a en los primeros 15
            días, te devolvemos el 100% de tu inversión. Sin preguntas. Sin
            formularios. Sin esperas.
            <br data-id="element-260" />
            <br data-id="element-261" />
            <strong data-id="element-262">Cero riesgo. Cero trampa.</strong>
          </p>
        </div>

        {/* FAQ */}
        <div className="mb-5" data-id="element-263">
          <h3 className="text-[20px] font-extrabold text-center mb-4 text-dark" data-id="element-264">
            ❓ PREGUNTAS FRECUENTES
          </h3>
          <div className="space-y-2" data-id="element-265">
            {[{
            q: '¿Necesito experiencia previa en IA?',
            a: 'No. El programa está diseñado para llevarte desde cero hasta experto. El Método CERTO funciona sin conocimientos técnicos previos. El 68% de nuestros estudiantes empezaron desde cero.'
          }, {
            q: '¿El certificado es realmente válido en Europa?',
            a: 'Sí. El certificado está homologado por AIN (Agrupación de Interés Económico, España) con validez oficial europea. Es verificable online y aceptado internacionalmente en más de 40 países.'
          }, {
            q: '¿Cuánto tiempo necesito dedicar?',
            a: 'Son 30 horas totales a tu ritmo. La mayoría completan el programa en 4-6 semanas dedicando 1 hora diaria. Puedes avanzar más rápido o más lento según tu disponibilidad.'
          }, {
            q: '¿Las herramientas tienen costo adicional?',
            a: 'La mayoría tienen versiones gratuitas suficientes: ChatGPT (versión free), Notion (plan free), Miro (plan free), JIRA (versión trial). Power BI Desktop es 100% gratuito.'
          }, {
            q: '¿Funciona para mi país de LATAM?',
            a: 'Sí. Tenemos estudiantes en México, Colombia, Argentina, Chile, Perú, Ecuador y más de 15 países latinoamericanos. El programa está diseñado específicamente para el profesional latinoamericano.'
          }].map((faq, i) => <div key={i} className="bg-white rounded-lg overflow-hidden border border-border" data-id="element-266">
                <div className="p-3.5 px-4 font-semibold text-[14px] cursor-pointer flex justify-between items-center text-dark hover:bg-surface" onClick={() => toggleFaq(i)} data-id="element-267">
                  {faq.q}
                  <ChevronDown size={18} className={`transition-transform duration-300 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-268" />
                </div>
                <div className={`text-[14px] text-textlight leading-[1.6] overflow-hidden transition-all duration-300 ease-in-out ${openFaq === i ? 'max-h-[200px] p-3 px-4 pt-0' : 'max-h-0 px-4'}`} data-id="element-269">
                  {faq.a}
                </div>
              </div>)}
          </div>
        </div>

        {/* Scarcity */}
        <div className="bg-gradient-to-br from-[#B71C1C] to-[#D32F2F] text-white rounded-xl py-4 px-5 text-center mb-4" data-id="element-270">
          <p className="text-[14px] mb-1 opacity-90" data-id="element-271">
            ⚠️ El precio especial de $297 USD es exclusivo para personas que
            completaron este test
          </p>
          <strong className="text-[16px]" data-id="element-272">
            Después de que expire el contador, el precio vuelve a $497 USD
          </strong>
        </div>

        {/* Final CTA */}
        <div className="text-center py-5" data-id="element-273">
          <div className="bg-[#B71C1C] text-white rounded-xl py-4 px-5 text-center mb-5" data-id="element-274">
            <p className="text-[13px] mb-1.5 opacity-90" data-id="element-275">
              ⏱️ Tu oferta expira en:
            </p>
            <div className="text-[40px] font-extrabold tracking-[4px] leading-none" data-id="element-276">
              {timeLeft}
            </div>
          </div>
          <button onClick={() => setCurrentPage('checkout')} className="bg-primary hover:bg-primary-hover text-white border-none rounded-xl py-4 px-8 text-[17px] font-bold cursor-pointer w-full block transition-all duration-200 shadow-primary hover:-translate-y-0.5" data-id="element-277">
            👉 SÍ, QUIERO MI CERTIFICACIÓN AHORA →
          </button>
          <p className="text-[12px] text-textlight mt-2.5" data-id="element-278">
            ✅ Acceso inmediato · 🛡️ Garantía 15 días · 🏅 Certificado Europeo
            Oficial
          </p>
        </div>
      </div>

      {/* Mobile Sticky CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-white p-3 shadow-[0_-4px_20px_rgba(0,0,0,0.12)] z-40 sm:hidden" data-id="element-279">
        <button onClick={() => setCurrentPage('checkout')} className="bg-primary hover:bg-[#e55a00] text-white border-none rounded-xl py-3.5 px-4 text-[15px] font-bold cursor-pointer w-full block transition-all duration-200" data-id="element-280">
          👉 QUIERO MI CERTIFICACIÓN — $297 USD
        </button>
      </div>
    </div>;
};